import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DistributorService } from 'src/app/services/distributor.service';
import * as XLSX from "xlsx";

@Component({
  selector: 'app-distributor-report',
  templateUrl: './distributor-report.component.html',
  styleUrls: ['./distributor-report.component.scss']
})
export class DistributorReportComponent implements OnInit {
  @ViewChild("TABLE") table: ElementRef;
  dataSource = new MatTableDataSource<any>();
  alldata: any = [];
  displayedColumns: string[] = [
    "DistributorCode",
    "DistributorName",
    "UsersEmail",
    "ContactFirstName",
    "ContactPhoneNumber",
    "Address",
    "AccountNumber",
    "ActiveInactive"
  ];
  count: number = 0;
  subMenu: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(
    public distributorService: DistributorService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private route: Router
  ) {
    const routeRes = this.route.getCurrentNavigation();
    if (routeRes.extras.state.subMenu)
      this.subMenu = routeRes.extras?.state?.subMenu;
  }

  ngOnInit(): void {
    this.spinner.show();
    // const submenu = "HVAC DISTRIBUTORS";
    this.distributorService.getReport(this.subMenu).subscribe((data) => {
      this.alldata = data;
      this.dataSource.data = this.alldata;
      this.count = data.length;
      this.spinner.hide();

      // Define custom filter predicate
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const dataStr = (
          data.DistributorCode +
          data.DistributorName +
          data.UsersEmail
        ).toLowerCase();
        return dataStr.includes(filter);
      };
    });
  }

  /**
   * formats text to capitalize first letter and lowercase rest
   * @param str 
   */
  formatText(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  /**
   filter the custom table tata
   * @event
  */
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.alldata);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, "DistributorDataReport" + ".xlsx");
  }

  exportToCSV() {
    const headers = this.displayedColumns;
    const rows = this.alldata.map((item: any) =>
      headers.map(header => {
        const value = item[header];
        // Escape quotes in CSV
        if (typeof value === 'string' && value.includes(',')) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value || '';
      }).join(',')
    );

    const csvContent = [
      headers.join(','),
      ...rows
    ].join('\n');

    this.downloadFile(csvContent, 'DistributorDataReport.csv', 'text/csv');
  }

  exportToTxt() {
    const headers = this.displayedColumns;
    const headerLine = headers.join('\t');
    
    const rows = this.alldata.map((item: any) =>
      headers.map(header => item[header] || '').join('\t')
    );

    const txtContent = [
      headerLine,
      ...rows
    ].join('\n');

    this.downloadFile(txtContent, 'DistributorDataReport.txt', 'text/plain');
  }

  private downloadFile(content: string, filename: string, mimeType: string) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:' + mimeType + ';charset=utf-8,' + encodeURIComponent(content));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
